import React, { forwardRef } from "react";
import IconBase, { IconProps } from "./icon-base";

export const VIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <IconBase
      ref={ref}
      renderPath={(color: string) => {
        return <path d="M1 4.5L4 8L10 1" stroke={color} strokeWidth="1.3" strokeLinecap="square" />;
      }}
      {...props}
    >
      {props.children}
    </IconBase>
  );
});

VIcon.displayName = "VIcon";
